export const websiteName = "AvatarTv";
